<app-user-dashboard [fullScreen]="true" [activeItem]="'home'">
  <div class="bg-container">
    <div class="container">
      <div class="pd-lat pd-top-bottom fade-in-js">
        <p-carousel [value]="carouselItems" [numVisible]="1" [circular]="true" [showNavigators]="false" [showIndicators]="true" [autoplayInterval]="7000" [responsiveOptions]="responsiveOptions" class="carousel-no-display custom-carousel .pd-lat">
          <ng-template let-item pTemplate="item">
            <div (click)="item.command($event)" class="carousel-container-img">
              <figure class="figure-img-bg">
                <img class="img-carousel" [src]="getImageBg(item.imageUrl, item.imageUrlEs)" alt="Banner image" loading="lazy">
              </figure>
            </div>
          </ng-template>
        </p-carousel>
      </div>

      <p-carousel [value]="carouselItemsMobile" [numVisible]="1" [circular]="true" [showNavigators]="false" [showIndicators]="true" [autoplayInterval]="7000" [responsiveOptions]="responsiveOptions" class="carousel-no-display-desktop custom-carousel fade-in-js">
        <ng-template let-item pTemplate="item">
            <div (click)="item.command($event)" class="carousel-container-img-mobile">
              <figure class="figure-img-bg">
                <img class="img-carousel" [src]="getImageBg(item.imageUrl, item.imageUrlEs)" alt="Banner image" loading="lazy">
              </figure>
            </div>
        </ng-template>
      </p-carousel>

      <div class="container-flex-gap">
        <div class="column-left-to-do">
          <h1 class="title-to-do-new fade-in-right-js">
            {{'HomePage.ToDoSection.ToDoTitle' | translate}} <span class="color-green">fruzty.com </span>
          </h1>
          <p class="text-p fade-in-up-js">
            {{'HomePage.ToDoSection.ToDoText' | translate}}.
          </p>
        </div>
        <div class="column-right-to-do">
          <div class="row-to-do fade-in-up-4-js">
            <div class="card" (click)="navigateToComex()">
              <div class="flex-column">
                <figure class="figure-icon-sq fade-in fade-in-delay-2">
                  <img loading="lazy" class="icon-to-do" alt="" src="../../../../assets/img/comex_icon.png" >
                </figure>
                <h3 class="title-card-to-do fade-in fade-in-delay-3">{{'HomePage.ToDoSection.ToDoTitleCard1' | translate}}</h3>
                <p class="text-card fade-in fade-in-delay-4">
                  {{'HomePage.ToDoSection.ToDoTextCard1' | translate}}.
                </p>
              </div>
            </div>
            <div class="card" (click)="navigateToInternationalMarketplace()">
              <div class="flex-column">
                <figure class="figure-icon-sq fade-in fade-in-delay-4">
                  <img loading="lazy" class="icon-to-do" alt="" src="../../../../assets/img/marketplace_icon.png" >
                </figure>
                <h3 class="title-card-to-dofade-in fade-in-delay-4">{{'HomePage.ToDoSection.ToDoTitleCard2' | translate}}</h3>
                <p class="text-card fade-in fade-in-delay-5">
                  {{'HomePage.ToDoSection.ToDoTextCard2' | translate}}.
                </p>
              </div>
            </div>
          </div>
          <div class="row-to-do fade-in-up-js" (click)="navigateToProcurement()">
            <div class="card fade-in-up fade-in-delay-5">
              <div class="flex-column">
                <figure class="figure-icon-sq fade-in fade-in-delay-6">
                  <img loading="lazy" class="icon-to-do" alt="" src="../../../../assets/img/procurement.png" >
                </figure>
                <h3 class="title-card-to-do fade-in fade-in-delay-6">{{'HomePage.ToDoSection.ToDoTitleCard3' | translate}}</h3>
                <p class="text-card fade-in fade-in-delay-7">
                  {{'HomePage.ToDoSection.ToDoTextCard3' | translate}}.
                </p>
              </div>
            </div>
            <div class="card fade-in-up fade-in-delay-7" (click)="navigateToSettlements()">
              <div class="flex-column">
                <figure class="figure-icon-sq fade-in fade-in-delay-8">
                  <img loading="lazy" class="icon-to-do" alt="" src="../../../../assets/img/liquidaciones_icon.png" >
                </figure>
                <h3 class="title-card-to-do fade-in fade-in-delay-8">{{'HomePage.ToDoSection.ToDoTitleCard4' | translate}}</h3>
                <p class="text-card fade-in fade-in-delay-9">
                  {{'HomePage.ToDoSection.ToDoTextCard4' | translate}}.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--
      <p-carousel [value]="carouselItemsOld" [numVisible]="1" [circular]="true" [showNavigators]="false" [showIndicators]="true" [autoplayInterval]="7000" [responsiveOptions]="responsiveOptions" class="carousel-no-display-desktop custom-carousel">
        <ng-template let-item pTemplate="item">
            <div [style]="{'background-color': item.backgroundColor}" class="carousel-container">
              <div class="carousel-column-left">
                <section class="carousel-msj">
                  <h1 class="title-carousel">
                    {{item.message | translate}}
                  </h1>
                  <h3 class="msj-carousel">
                    {{item.description | translate}}
                  </h3>
                  <button (click)="navigateToMarketplace()" class="ghost-btn mg-top">{{item.btn | translate}}</button>
                </section>
              </div>
              <div class="carousel-column-right">
                <figure class="carousel-figure">
                  <img class="carousel-img" [src]="item.imageUrl2" alt="Banner image">
                </figure>
              </div>
            </div>
        </ng-template>
      </p-carousel>
      -->
      <!--
      <div class="section-title">
        <h1 class="title-section">{{'HomePage.OurServicesText' | translate}}</h1>
      </div>

      <div class="container-services" *ngIf="services">
        <div *ngFor="let service of services" class="card-services">
          <figure class="figure-services">
            <img alt="service icon" src={{service.iconUrl}} class="icon-img" loading="lazy">
          </figure>
          <p class="text-p">{{service.message | translate}}</p>
        </div>
      </div>
      -->


      <div class="section-title fade-in-js">
        <h1 class="title-section fade-in-left fade-in-delay">{{'HomePage.ProductsTitle' | translate}}</h1>
      </div>
      <div class="container-cards" *ngIf="offersTrimmed">
        <div class="subcontainer-cards fade-in-js">
          <div class="flex w-12 sm:w-6 lg:w-4 p-3 fade-in fade-in-delay-2" *ngFor="let offer of offersTrimmed">
            <app-product-card
              class="w-full"
              [offer]="offer"
              (navigateTo)="navigateToDetail(offer.adsCode)"
            />
          </div>
        </div>
      </div>
      <div class="section-btn fade-in-js">
        <button class="main-btn fade-in fade-in-delay-4" (click)="navigateToMarketplace()">{{'HomePage.MarketplaceBtn' | translate}}</button>
      </div>


      <!--
      <div class="section-title">
        <h1 class="title-section">{{'HomePage.ToDoFruztyTitle' | translate}}</h1>
      </div>

      <div class="container-cards-to-do carousel-no-display"  *ngIf="services" #carToDo>
        <div class="container-flex" *ngFor="let item of toDo">
          <div class="card-to-do">
            <figure class="figure-to-do">
              <img alt="service icon" src={{item.iconUrl}} class="icon-img" loading="lazy">
            </figure>
            <section class="section-to-do">
              <h2 class="title-to-do">{{item.title | translate}}</h2>
              <p class="text-to-do">{{item.message | translate}}</p>
            </section>
            <button class="ghost-btn-color" (click)="goToNav(item.url)">{{'HomePage.ToDoBtn' | translate}}</button>
          </div>
        </div>
      </div>
      -->


      <!--
      <div class="container-cards-to-do carousel-no-display-desktop"  *ngIf="services" #carToDo>
        <div *ngFor="let item of toDo">
          <div class="card-to-do">
            <figure class="figure-to-do">
              <img alt="service icon" src={{item.iconUrl}} class="icon-img" loading="lazy">
            </figure>
            <section class="section-to-do">
              <h2 class="title-to-do">{{item.title | translate}}</h2>
              <p class="text-to-do">{{item.message | translate}}</p>
            </section>
            <button pButton class="ghost-btn-color" (click)="goToNav(item.url)">{{'HomePage.ToDoBtn' | translate}}</button>
          </div>
        </div>
      </div>
      -->



        <!--
      <div class="carousel-no-display pd-top mg-bottom">
        <p-carousel [value]="carouselToDo" [numVisible]="1" [circular]="true" [showNavigators]="false" [showIndicators]="true" [autoplayInterval]="7000" [responsiveOptions]="responsiveOptions" class="carousel-no-display custom-carousel">
          <ng-template let-item pTemplate="item">
            <div class="carousel-container-to-do pd-lat">
              <figure class="figure-img-bg-to-do">
                <img class="img-carousel" [src]="getImageBg(item.imageUrl, item.imageUrlEs)" alt="Banner image" loading="lazy">
              </figure>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    -->
    </div>
  </div>
</app-user-dashboard>
<app-footer-home></app-footer-home>
